const ChartererList = () => import("@/views/charterer/ChartererList.vue")
const ChartererChange = () => import("@/views/charterer/ChartererChange.vue")
const ChartererOnboarding = () => import("@/views/charterer/ChartererOnboarding.vue")
const ChartererRequestList = () => import("@/views/charterer/request/ChartererRequestList.vue")
const ChartererRequestForm = () => import("@/views/charterer/request/ChartererRequestForm.vue")
const ChartererRequestDetail = () => import("@/views/charterer/request/ChartererRequestDetail.vue")
const ChartererQuoteDetail = () => import("@/views/charterer/quote/ChartererQuoteDetail.vue")
const ChartererMessages = () => import("@/views/Messages.vue")
const ChartererShipments = () => import("@/views/Shipments.vue")
const ChartererShipmentDetails = () => import("@/views/ShipmentDetails.vue")
const ChartererContracts = () => import("@/views/charterer/contract/ChartererContractList.vue")
const Notifications = () => import("@/views/Notifications.vue")

const charterer_routes = [
  {
    path: '',
    redirect: '/dashboard'
  },
  {
    path: 'notifications',
    name: 'ChartererNotifications',
    component: Notifications,
    props: route => ({params: route.query}),
    meta: {requiresAuth: true}
  },
  {
    path: 'messages',
    name: 'ChartererMessages',
    component: ChartererMessages,
    props: route => ({params: route.query}),
    meta: {requiresAuth: true}
  },
  {
    path: 'shipments',
    meta: {breadcrumb: 'Charterer Shipments'},
    children: [
      {
        path: '',
        name: 'ChartererShipments',
        component: ChartererShipments,
        props: route => ({params: route.query}),
        meta: {breadcrumb: false},
      },
      {
        path: ':pk',
        name: 'ChartererShipmentDetails',
        component: ChartererShipmentDetails,
        props: route => ({params: route.query, pk: route.params.pk}),
        meta: {breadcrumb: 'Shipment Details'},
      },
    ]
  },
  {
    path: 'contracts',
    name: 'ChartererContracts',
    component: ChartererContracts,
    props: route => ({params: route.query}),
    meta: {requiresAuth: true}
  },
  {
    path: 'request',
    meta: {breadcrumb: 'Charter Request'},
    children: [
      {
        path: '',
        name: 'ChartererRequestList',
        component: ChartererRequestList,
        props: route => ({params: route.query}),
        meta: {breadcrumb: false},
      }, {
        path: 'form/:pk?',
        name: 'ChartererRequestForm',
        component: ChartererRequestForm,
        props: route => ({params: route.query, pk: route.params.pk}),
        meta: {breadcrumb: 'Form'},
      },
      {
        path: ':pk',
        name: 'ChartererRequestDetail',
        component: ChartererRequestDetail,
        props: route => ({params: route.query, pk: route.params.pk}),
        meta: {breadcrumb: 'Detail'},
      },
      {
        path: ':requestId/quote/:pk?',
        name: 'ChartererQuoteDetail',
        component: ChartererQuoteDetail,
        props: route => ({params: route.query, pk: route.params.pk}),
        meta: {breadcrumb: 'Detail'},
      },
    ]
  },
  {
    path: 'list',
    name: 'ChartererList',
    component: ChartererList,
    props: route => ({params: route.query})
  },
  {
    path: 'onboarding',
    name: 'ChartererOnboarding',
    component: ChartererOnboarding,
    props: route => ({params: route.query})
  },
  {
    path: ':pk',
    name: 'ChartererChange',
    component: ChartererChange,
    props: route => ({params: route.query, pk: route.params.pk})
  }
]

export default charterer_routes
